import { StateCreator } from 'zustand';

import { RemoteBoundStoreState } from 'src/store/useRemoteBoundStore';

import { initData } from 'src/models/InitialData.model';
import { Session } from 'src/models/Session.model';

interface StateTypes {
  session: Session;
}

type ActionsTypes = {
  setSession: (session: Session) => void;
  resetSession: () => void;
  updateSession: (partialSession: Partial<Session>) => void;
};

export type SessionSliceTypes = StateTypes & ActionsTypes;

const initialState: StateTypes = {
  session: initData.tempSession,
};

export const createSessionSlice: StateCreator<
  RemoteBoundStoreState,
  [],
  [],
  SessionSliceTypes
> = (set) => ({
  ...initialState,

  setSession: (session: Session) => set({ session }),

  resetSession: () => set({ session: initData.tempSession }),

  updateSession: (partialSession: Partial<Session>) =>
    set((state) => ({
      session: { ...state.session, ...partialSession },
    })),
});
